import { Modal } from 'react-bootstrap';
import { FaExchangeAlt, FaInfoCircle } from 'react-icons/fa';

const TransactionHeader = ({ security, onClose }) => {
  return (
    <Modal.Header closeButton className="bg-gradient-primary text-white">
      <Modal.Title className="d-flex align-items-center w-100">
        <div className="d-flex align-items-center me-3">
          <div className="icon-container bg-white bg-opacity-20 p-2 rounded-circle me-3">
            <FaExchangeAlt size={24} />
          </div>
          <div className='text-white'>
            <h4 className="mb-0 fw-bold">Nouvelle Transaction</h4>
            <div className="d-flex align-items-center mt-1">
              <FaInfoCircle size={14} className="me-1 opacity-75" />
              <small className="opacity-90">
                {security?.securityName || 'Sélectionnez un titre'}
              </small>
            </div>
          </div>
        </div>

      </Modal.Title>
    </Modal.Header>
  );
};

export default TransactionHeader;